export class PauseTicket {
    pauseTime: number;
    returnToDesk: boolean;
}